import validate from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@22.17.0_@vue+compiler-sfc@3.5.17_db0@0.3._6cf49b862fc58a113b598ba5521ca066/node_modules/nuxt/dist/pages/runtime/validate.js";
import manifest_45route_45rule from "/vercel/path0/node_modules/.pnpm/nuxt@3.17.7_@parcel+watcher@2.5.1_@types+node@22.17.0_@vue+compiler-sfc@3.5.17_db0@0.3._6cf49b862fc58a113b598ba5521ca066/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  manifest_45route_45rule
]
export const namedMiddleware = {}